import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import { ninja } from "@vitalsource/vstui/colors";

const ToolTip = styled.button`
  background: ${ninja.getShade(10)};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  bottom: ${props => props.toolTipBottom};
  right: ${props => props.toolTipRight};
  position: absolute;
  padding: 10px 20px;
  width: 250px;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  &#tooltip-with-arrow:after {
    content: "";
    position: absolute;
    top: 100%;
    left: ${props => props.arrow};
    margin-left: -15px;
    width: 0;
    height: 0;
    border-top: solid 10px ${ninja.getShade(10)};
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
`;

const Container = styled.div`
  position: relative;
`;

class ScrubberToolTip extends React.Component {
  constructor(props) {
    super(props);

    const isMobile = Fraction.Helpers.isSmallScreen();
    this.toolTipWithArrow = null;
    this.icon = null;

    // unless ToolTip offscreen (icons branded away),
    // positioning state will not change
    this.state = {
      seen: !!props.seen,
      arrow: isMobile ? "75%" : "50%",
      toolTipBottom: isMobile ? "20px" : "42px",
      toolTipRight: isMobile ? "10px" : "-115px"
    };
  }

  componentDidMount() {
    if (this.toolTipWithArrow && this.icon) {
      this.updateMobileArrow();
      const popup = this.toolTipWithArrow.getBoundingClientRect();
      const windowSize = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );

      if (popup.x + popup.width > windowSize) {
        const diff = popup.x + popup.width - windowSize;
        const iconCenter =
          this.icon.children[0].getBoundingClientRect().width / 2;
        const arrow = windowSize - popup.left - iconCenter;
        this.setState({
          toolTipRight: `-${diff}px`,
          arrow: `${arrow}px`
        });
      }
    }
  }

  updateMobileArrow() {
    // This lives here because reader/container.jsx houses
    // logic for hiding mobile scrubber contents
    if (Fraction.Helpers.isSmallScreen()) {
      const mobileScrubber = document.getElementById(
        "mobile-scrubber-container"
      );
      if (mobileScrubber && mobileScrubber.style.bottom !== "0px") {
        $("#tooltip-with-arrow").hide();
      }
    }
  }

  toolTipClick() {
    this.props.onClick && this.props.onClick();
    this.setState({ seen: true });
  }

  render() {
    const { seen, arrow, toolTipRight, toolTipBottom } = this.state;
    const { text, icon } = this.props;

    if (!seen && text) {
      return (
        <Container>
          <ToolTip
            id="tooltip-with-arrow"
            innerRef={component => (this.toolTipWithArrow = component)}
            toolTipBottom={toolTipBottom}
            toolTipRight={toolTipRight}
            arrow={arrow}
            onClick={() => {
              this.toolTipClick();
            }}
          >
            {text}
          </ToolTip>
          <span ref={icon => (this.icon = icon)}>{icon}</span>
        </Container>
      );
    }

    return <span>{icon}</span>;
  }
}

ScrubberToolTip.propTypes = {
  seen: PropTypes.bool.isRequired,
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default ScrubberToolTip;
